// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.h1-headline-800 h1 {
    /* color: var(--Color-Brand-Text-Highlight, #0027F9); */
    font-family: var(--Font-Family-All-purpose, Poppins);
    font-size: var(--Font-Size-Heading-Home-Hero, 96px);
    font-style: normal;
    font-weight: 800;
    line-height: 120%;
    letter-spacing: -1.92px;
}

.h1-headline-500 {
    color: var(--Color-Brand-Text-Default, #0B1547);
    font-family: Poppins;
    font-size: 96px;
    font-style: normal;
    font-weight: 500;
    line-height: 120%;
    letter-spacing: -1.92px;
}

.h2-headline-800 h2 {
    /* color: var(--Color-Brand-Text-Highlight, #0027F9); */
    font-family: var(--Font-Family-All-purpose, Poppins);
    font-size: var(--Font-Size-Heading-Banner-Footer, 88px);
    font-style: normal;
    font-weight: 800;
    line-height: 120%;
    letter-spacing: -0.88px;
}

.h2-headline-500 {
    color: var(--Color-Brand-Text-Default, #0B1547);
    font-family: var(--Font-Family-All-purpose, Poppins);
    font-size: var(--Font-Size-Heading-Banner-Footer, 88px);
    font-style: normal;
    font-weight: 500;
    line-height: 120%;
    letter-spacing: -0.88px;
}

.h2-headline-500-mobile {
    color: var(--Text-Color-text-primary-black, #131927);
    font-family: Poppins;
    font-size: 48px;
    font-style: normal;
    font-weight: 500;
    line-height: 57.6px; /* 57.6px */
    letter-spacing: -0.48px;
}

.h3-headline-800 {
    color: var(--Color-Brand-Text-Highlight, #0027F9);
    font-family: var(--Font-Family-All-purpose, Poppins);
    font-size: var(--Font-Size-Heading-Hero, 72px);
    font-style: normal;
    font-weight: 800;
    line-height: 110%;
    letter-spacing: -0.72px;
}

.h3-headline-500 {
    color: var(--Color-Brand-Text-Default, #0B1547);
    font-family: var(--Font-Family-All-purpose, Poppins);
    font-size: var(--Font-Size-Heading-Hero, 72px);
    font-style: normal;
    font-weight: 500;
    line-height: 110%;
    letter-spacing: -0.72px;
}

.h4-headline-800 {
    color: var(--Color-Brand-Text-Highlight, #0027F9);
    font-family: var(--Font-Family-All-purpose, Poppins);
    font-size: var(--Font-Size-Subtitle-Country-Payment, 48px);
    font-style: normal;
    font-weight: 800;
    line-height: 105%;
    letter-spacing: -0.96px;
}

.h4-headline-500 {
    color: var(--Color-Brand-Text-Default, #0B1547);
    font-family: var(--Font-Family-All-purpose, Poppins);
    font-size: var(--Font-Size-Subtitle-Country-Payment, 44px);
    font-style: normal;
    font-weight: 500;
    line-height: 110%;
    letter-spacing: -0.96px;
}

.h4-headline-500 strong {
    font-weight: 800;
}

.s1-subtitle-600 {
    color: var(--Color-Brand-Text-Highlight, #0027F9);
    font-family: var(--Font-Family-All-purpose, Poppins);
    font-size: var(--Font-Size-Subtitle-Card-XL-2, 40px);
    font-style: normal;
    font-weight: 600;
    line-height: 120%; /* 48px */
    letter-spacing: -0.4px;
}
.s2-subtitle-800 {
    color: #0027F9 !important;
    font-family: var(--Font-Family-All-purpose, Poppins);
    font-size: var(--Font-Size-Subtitle-Card-XL, 32px);
    font-style: normal;
    font-weight: 800;
    line-height: 120%;
}

.s3-subtitle-600 {
    color: var(--Color-Brand-Text-Default, #0B1547);
    font-family: var(--Font-Family-All-purpose, Poppins);
    font-size: var(--Font-Size-Subtitle-News-Title-Card-S, 26px);
    font-style: normal;
    font-weight: 600;
    line-height: 120%;
    letter-spacing: -0.26px;
}

.s4-subtitle-500 {
    color: #0B1547;
    text-align: center;
    font-family: var(--Font-Family-All-purpose, Poppins);
    font-size: var(--Font-Size-Subtitle-Hero-Home, 24px);
    font-style: normal;
    font-weight: 500;
    line-height: 120%;
}

.b1-body-800 {
    color: var(--Color-Brand-Text-Default, #0B1547);
    font-family: var(--Font-Family-All-purpose, Poppins);
    font-size: var(--Font-Size-Body-General, 20px);
    font-style: normal;
    font-weight: 800;
    line-height: normal;
}

.b2-body-400,
.b2-body-400 a {
    color: var(--Color-Brand-Text-Default, #0B1547);
    font-family: var(--Font-Family-All-purpose, Poppins);
    font-size: var(--Font-Size-Body-General, 24px);
    font-style: normal;
    font-weight: 400;
    line-height: 140%;
}

.b3-body-400 {
    color: var(--Color-Brand-Text-Default, #0B1547);
    font-family: var(--Font-Family-All-purpose, Poppins);
    font-size: var(--Font-Size-Body-General, 22px);
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}

.b4-body-400 {
    color: var(--Color-Brand-Text-Default, #0B1547);
    font-family: var(--Font-Family-All-purpose, Poppins);
    font-size: var(--Font-Size-Button-Link-Arrow, 18px);
    font-style: normal;
    font-weight: 400;
    line-height: 140%;
}

.b2-body-400 h1 {
    line-height: 120%
}

.b4-body-500 {
    color: var(--Color-Brand-Text-Default, #0B1547);
    font-family: var(--Font-Family-All-purpose, Poppins);
    font-size: var(--Font-Size-Button-Link-Arrow, 18px);
    font-style: normal;
    font-weight: 500;
    line-height: 140%;
}

.b5-body-400 {
    color: var(--Color-Brand-Text-Default, #0B1547);
    font-family: var(--Font-Family-All-purpose, Poppins);
    font-size: var(--Font-Size-Button-Link-Arrow, 14px);
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}

.b5-body-500 {
    color: var(--Color-Brand-Text-Default, #0B1547);
    font-family: var(--Font-Family-All-purpose, Poppins);
    font-size: var(--Font-Size-Button-Link-Arrow, 14px);
    font-style: normal;
    font-weight: 500;
    line-height: normal;
}

.b5-body-700 {
    color: var(--Color-Brand-Text-Default, #0B1547);
    font-family: var(--Font-Family-All-purpose, Poppins);
    font-size: var(--Font-Size-Button-Link-Arrow, 14px);
    font-style: normal;
    font-weight: 700;
    line-height: normal;
}

.b6-body-400 {
    color: var(--Color-Brand-Text-Default, #0B1547);
    font-family: var(--Font-Family-All-purpose, Poppins);
    font-size: var(--Font-Size-Button-Link-Arrow, 16px);
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}

.b2-body-400-mobile {
    color: var(--Text-Color-text-primary-black, #131927);
    font-family: Poppins;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}

@media screen and (max-width: 1024px) {

    .h1-headline-800 h1 {
        font-size: 54px;
        line-height: 110%;
    }

    .h4-headline-800 {
        font-size: 32px;
    }
    .h4-headline-500 {
        font-size: 32px;
    }
    .b2-body-400 {
        font-size: 16px !important;
    }

    .h2-headline-500-mobile h2 {
        padding-bottom: 0 !important;
    }
    
  }

.bt-medium-500 {
    font-family: var(--Font-Family-All-purpose, Poppins);
    font-size: var(--Font-Size-Button-Link-Arrow, 18px);
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    padding: 0;
}

.bt-medium-500:hover {
    color: var(--Color-Bright, #FFF);
}

.bt-small-500 {
    color: var(--Color-Neutral-Button-Text-Disable, #8F8F8F);
    font-family: var(--Font-Family-All-purpose, Poppins);
    font-size: var(--Font-Size-Button-Small-Nav, 16px);
    font-style: normal;
    font-weight: 500;
    line-height: 16px;
    padding: 0;
}

.bt-small-400 {
    color: #0027F9;
    font-family: Poppins;
    font-size: var(--Font-Size-Button-Small-Nav, 14px);
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    padding: 0;
}

@media screen and (max-width: 1024px) {
    .b2-body-400 {
        font-size: 18px;
    }
}


@media screen and (max-width: 1300px) {
    .bt-medium-500 {
        font-size: var(--Font-Size-Button-Link-Arrow, 16px);
    }

    .b4-body-400 {
        font-size: 16px;
    }
    .b4-body-500 {
        font-size: 16px;
    }
}`, "",{"version":3,"sources":["webpack://./src/css/Typography.css"],"names":[],"mappings":"AAAA;IACI,uDAAuD;IACvD,oDAAoD;IACpD,mDAAmD;IACnD,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,uBAAuB;AAC3B;;AAEA;IACI,+CAA+C;IAC/C,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,uBAAuB;AAC3B;;AAEA;IACI,uDAAuD;IACvD,oDAAoD;IACpD,uDAAuD;IACvD,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,uBAAuB;AAC3B;;AAEA;IACI,+CAA+C;IAC/C,oDAAoD;IACpD,uDAAuD;IACvD,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,uBAAuB;AAC3B;;AAEA;IACI,oDAAoD;IACpD,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB,EAAE,WAAW;IAChC,uBAAuB;AAC3B;;AAEA;IACI,iDAAiD;IACjD,oDAAoD;IACpD,8CAA8C;IAC9C,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,uBAAuB;AAC3B;;AAEA;IACI,+CAA+C;IAC/C,oDAAoD;IACpD,8CAA8C;IAC9C,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,uBAAuB;AAC3B;;AAEA;IACI,iDAAiD;IACjD,oDAAoD;IACpD,0DAA0D;IAC1D,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,uBAAuB;AAC3B;;AAEA;IACI,+CAA+C;IAC/C,oDAAoD;IACpD,0DAA0D;IAC1D,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iDAAiD;IACjD,oDAAoD;IACpD,oDAAoD;IACpD,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB,EAAE,SAAS;IAC5B,sBAAsB;AAC1B;AACA;IACI,yBAAyB;IACzB,oDAAoD;IACpD,kDAAkD;IAClD,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,+CAA+C;IAC/C,oDAAoD;IACpD,4DAA4D;IAC5D,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,uBAAuB;AAC3B;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,oDAAoD;IACpD,oDAAoD;IACpD,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,+CAA+C;IAC/C,oDAAoD;IACpD,8CAA8C;IAC9C,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;;IAEI,+CAA+C;IAC/C,oDAAoD;IACpD,8CAA8C;IAC9C,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,+CAA+C;IAC/C,oDAAoD;IACpD,8CAA8C;IAC9C,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,+CAA+C;IAC/C,oDAAoD;IACpD,mDAAmD;IACnD,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI;AACJ;;AAEA;IACI,+CAA+C;IAC/C,oDAAoD;IACpD,mDAAmD;IACnD,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,+CAA+C;IAC/C,oDAAoD;IACpD,mDAAmD;IACnD,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,+CAA+C;IAC/C,oDAAoD;IACpD,mDAAmD;IACnD,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,+CAA+C;IAC/C,oDAAoD;IACpD,mDAAmD;IACnD,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,+CAA+C;IAC/C,oDAAoD;IACpD,mDAAmD;IACnD,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,oDAAoD;IACpD,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;;IAEI;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,0BAA0B;IAC9B;;IAEA;QACI,4BAA4B;IAChC;;EAEF;;AAEF;IACI,oDAAoD;IACpD,mDAAmD;IACnD,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,wDAAwD;IACxD,oDAAoD;IACpD,kDAAkD;IAClD,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,UAAU;AACd;;AAEA;IACI,cAAc;IACd,oBAAoB;IACpB,kDAAkD;IAClD,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;;AAGA;IACI;QACI,mDAAmD;IACvD;;IAEA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;AACJ","sourcesContent":[".h1-headline-800 h1 {\n    /* color: var(--Color-Brand-Text-Highlight, #0027F9); */\n    font-family: var(--Font-Family-All-purpose, Poppins);\n    font-size: var(--Font-Size-Heading-Home-Hero, 96px);\n    font-style: normal;\n    font-weight: 800;\n    line-height: 120%;\n    letter-spacing: -1.92px;\n}\n\n.h1-headline-500 {\n    color: var(--Color-Brand-Text-Default, #0B1547);\n    font-family: Poppins;\n    font-size: 96px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 120%;\n    letter-spacing: -1.92px;\n}\n\n.h2-headline-800 h2 {\n    /* color: var(--Color-Brand-Text-Highlight, #0027F9); */\n    font-family: var(--Font-Family-All-purpose, Poppins);\n    font-size: var(--Font-Size-Heading-Banner-Footer, 88px);\n    font-style: normal;\n    font-weight: 800;\n    line-height: 120%;\n    letter-spacing: -0.88px;\n}\n\n.h2-headline-500 {\n    color: var(--Color-Brand-Text-Default, #0B1547);\n    font-family: var(--Font-Family-All-purpose, Poppins);\n    font-size: var(--Font-Size-Heading-Banner-Footer, 88px);\n    font-style: normal;\n    font-weight: 500;\n    line-height: 120%;\n    letter-spacing: -0.88px;\n}\n\n.h2-headline-500-mobile {\n    color: var(--Text-Color-text-primary-black, #131927);\n    font-family: Poppins;\n    font-size: 48px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 57.6px; /* 57.6px */\n    letter-spacing: -0.48px;\n}\n\n.h3-headline-800 {\n    color: var(--Color-Brand-Text-Highlight, #0027F9);\n    font-family: var(--Font-Family-All-purpose, Poppins);\n    font-size: var(--Font-Size-Heading-Hero, 72px);\n    font-style: normal;\n    font-weight: 800;\n    line-height: 110%;\n    letter-spacing: -0.72px;\n}\n\n.h3-headline-500 {\n    color: var(--Color-Brand-Text-Default, #0B1547);\n    font-family: var(--Font-Family-All-purpose, Poppins);\n    font-size: var(--Font-Size-Heading-Hero, 72px);\n    font-style: normal;\n    font-weight: 500;\n    line-height: 110%;\n    letter-spacing: -0.72px;\n}\n\n.h4-headline-800 {\n    color: var(--Color-Brand-Text-Highlight, #0027F9);\n    font-family: var(--Font-Family-All-purpose, Poppins);\n    font-size: var(--Font-Size-Subtitle-Country-Payment, 48px);\n    font-style: normal;\n    font-weight: 800;\n    line-height: 105%;\n    letter-spacing: -0.96px;\n}\n\n.h4-headline-500 {\n    color: var(--Color-Brand-Text-Default, #0B1547);\n    font-family: var(--Font-Family-All-purpose, Poppins);\n    font-size: var(--Font-Size-Subtitle-Country-Payment, 44px);\n    font-style: normal;\n    font-weight: 500;\n    line-height: 110%;\n    letter-spacing: -0.96px;\n}\n\n.h4-headline-500 strong {\n    font-weight: 800;\n}\n\n.s1-subtitle-600 {\n    color: var(--Color-Brand-Text-Highlight, #0027F9);\n    font-family: var(--Font-Family-All-purpose, Poppins);\n    font-size: var(--Font-Size-Subtitle-Card-XL-2, 40px);\n    font-style: normal;\n    font-weight: 600;\n    line-height: 120%; /* 48px */\n    letter-spacing: -0.4px;\n}\n.s2-subtitle-800 {\n    color: #0027F9 !important;\n    font-family: var(--Font-Family-All-purpose, Poppins);\n    font-size: var(--Font-Size-Subtitle-Card-XL, 32px);\n    font-style: normal;\n    font-weight: 800;\n    line-height: 120%;\n}\n\n.s3-subtitle-600 {\n    color: var(--Color-Brand-Text-Default, #0B1547);\n    font-family: var(--Font-Family-All-purpose, Poppins);\n    font-size: var(--Font-Size-Subtitle-News-Title-Card-S, 26px);\n    font-style: normal;\n    font-weight: 600;\n    line-height: 120%;\n    letter-spacing: -0.26px;\n}\n\n.s4-subtitle-500 {\n    color: #0B1547;\n    text-align: center;\n    font-family: var(--Font-Family-All-purpose, Poppins);\n    font-size: var(--Font-Size-Subtitle-Hero-Home, 24px);\n    font-style: normal;\n    font-weight: 500;\n    line-height: 120%;\n}\n\n.b1-body-800 {\n    color: var(--Color-Brand-Text-Default, #0B1547);\n    font-family: var(--Font-Family-All-purpose, Poppins);\n    font-size: var(--Font-Size-Body-General, 20px);\n    font-style: normal;\n    font-weight: 800;\n    line-height: normal;\n}\n\n.b2-body-400,\n.b2-body-400 a {\n    color: var(--Color-Brand-Text-Default, #0B1547);\n    font-family: var(--Font-Family-All-purpose, Poppins);\n    font-size: var(--Font-Size-Body-General, 24px);\n    font-style: normal;\n    font-weight: 400;\n    line-height: 140%;\n}\n\n.b3-body-400 {\n    color: var(--Color-Brand-Text-Default, #0B1547);\n    font-family: var(--Font-Family-All-purpose, Poppins);\n    font-size: var(--Font-Size-Body-General, 22px);\n    font-style: normal;\n    font-weight: 400;\n    line-height: normal;\n}\n\n.b4-body-400 {\n    color: var(--Color-Brand-Text-Default, #0B1547);\n    font-family: var(--Font-Family-All-purpose, Poppins);\n    font-size: var(--Font-Size-Button-Link-Arrow, 18px);\n    font-style: normal;\n    font-weight: 400;\n    line-height: 140%;\n}\n\n.b2-body-400 h1 {\n    line-height: 120%\n}\n\n.b4-body-500 {\n    color: var(--Color-Brand-Text-Default, #0B1547);\n    font-family: var(--Font-Family-All-purpose, Poppins);\n    font-size: var(--Font-Size-Button-Link-Arrow, 18px);\n    font-style: normal;\n    font-weight: 500;\n    line-height: 140%;\n}\n\n.b5-body-400 {\n    color: var(--Color-Brand-Text-Default, #0B1547);\n    font-family: var(--Font-Family-All-purpose, Poppins);\n    font-size: var(--Font-Size-Button-Link-Arrow, 14px);\n    font-style: normal;\n    font-weight: 400;\n    line-height: normal;\n}\n\n.b5-body-500 {\n    color: var(--Color-Brand-Text-Default, #0B1547);\n    font-family: var(--Font-Family-All-purpose, Poppins);\n    font-size: var(--Font-Size-Button-Link-Arrow, 14px);\n    font-style: normal;\n    font-weight: 500;\n    line-height: normal;\n}\n\n.b5-body-700 {\n    color: var(--Color-Brand-Text-Default, #0B1547);\n    font-family: var(--Font-Family-All-purpose, Poppins);\n    font-size: var(--Font-Size-Button-Link-Arrow, 14px);\n    font-style: normal;\n    font-weight: 700;\n    line-height: normal;\n}\n\n.b6-body-400 {\n    color: var(--Color-Brand-Text-Default, #0B1547);\n    font-family: var(--Font-Family-All-purpose, Poppins);\n    font-size: var(--Font-Size-Button-Link-Arrow, 16px);\n    font-style: normal;\n    font-weight: 400;\n    line-height: normal;\n}\n\n.b2-body-400-mobile {\n    color: var(--Text-Color-text-primary-black, #131927);\n    font-family: Poppins;\n    font-size: 18px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: normal;\n}\n\n@media screen and (max-width: 1024px) {\n\n    .h1-headline-800 h1 {\n        font-size: 54px;\n        line-height: 110%;\n    }\n\n    .h4-headline-800 {\n        font-size: 32px;\n    }\n    .h4-headline-500 {\n        font-size: 32px;\n    }\n    .b2-body-400 {\n        font-size: 16px !important;\n    }\n\n    .h2-headline-500-mobile h2 {\n        padding-bottom: 0 !important;\n    }\n    \n  }\n\n.bt-medium-500 {\n    font-family: var(--Font-Family-All-purpose, Poppins);\n    font-size: var(--Font-Size-Button-Link-Arrow, 18px);\n    font-style: normal;\n    font-weight: 400;\n    line-height: normal;\n    padding: 0;\n}\n\n.bt-medium-500:hover {\n    color: var(--Color-Bright, #FFF);\n}\n\n.bt-small-500 {\n    color: var(--Color-Neutral-Button-Text-Disable, #8F8F8F);\n    font-family: var(--Font-Family-All-purpose, Poppins);\n    font-size: var(--Font-Size-Button-Small-Nav, 16px);\n    font-style: normal;\n    font-weight: 500;\n    line-height: 16px;\n    padding: 0;\n}\n\n.bt-small-400 {\n    color: #0027F9;\n    font-family: Poppins;\n    font-size: var(--Font-Size-Button-Small-Nav, 14px);\n    font-style: normal;\n    font-weight: 400;\n    line-height: normal;\n    padding: 0;\n}\n\n@media screen and (max-width: 1024px) {\n    .b2-body-400 {\n        font-size: 18px;\n    }\n}\n\n\n@media screen and (max-width: 1300px) {\n    .bt-medium-500 {\n        font-size: var(--Font-Size-Button-Link-Arrow, 16px);\n    }\n\n    .b4-body-400 {\n        font-size: 16px;\n    }\n    .b4-body-500 {\n        font-size: 16px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
